<script>
import { mapActions, mapState, mapMutations } from "vuex";
import SearchResults from "../search/searchResults.vue";
import SearchResultsViewChange from "../search/searchResultsViewChange.vue";
import SearchingImageSection from "../search/searchingImageSection.vue";
import LoadMore from "../search/loadMore.vue";
import ViewMore from "../search/viewMore.vue";
import SearchSection from "../package/searchSection.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import FooterSection from "../package/footerSection.vue";
import AdvertisementTwo from "../search/advertisementTwo.vue";
import AdvertisementOne from "../search/advertisementOne.vue";
import AdvertisementThree from "../search/advertisementThree.vue";
import SimilarProperties from "../search/similarProperties.vue";
import BreadcrumbSection from "../package/breadcrumbSection.vue";
import TopImageSection from "../package/topImageSection.vue";
import BuyOffPlanSection from "../package/buyOffPlanSection.vue";
import agentSignInSection from "../package/agentSignInSection.vue";
import discoverMore from "../package/discoverMore.vue";
import StayUpToDate from "../package/stayUpToDate.vue";
import SocialSection from "../package/socialSection.vue";
import ConnectingProperties from "../package/connectingProperties.vue";
import AgentsRegistration from "../package/agentsRegistration.vue";
import ContactUs from "../package/contactUs.vue";
import FindOutMore from "../package/findOutMore.vue";
import ListingDetailsTabs from "./listingDetailsTabs.vue";
import ListingDetails from "./listingDetails.vue";
import MeetAgent from "./meetAgent.vue";
import ListingLocation from "./listingLocation.vue";
import MoreFromAgent from "./moreFromAgent.vue";
import ReserveProperty from "./reserveProperty.vue";
import DrawerAside from "../package/DrawerAside.vue";
import HeaderSection from "../package/HeaderSection.vue";

export default {
  name: "detailsLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D",
      item: {},

      currentRoom: {},
      listFloorPlan: [],
      isLoading: true
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);

    if (this.$route.query.pid) {
      this.getPropertyDtl({
        params: { id: this.$route.query.pid },
        callback: this.callback
      });
    }
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    ...mapActions("property", ["getPropertyDtl", "share"]),
    ...mapMutations("property", ["setPropertyDtl"]),
    updateRow(row) {
      this.currentRoom = row;
      console.log("this.currentRoom-----------------------");
      console.log(this.currentRoom);
    },
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    },

    callback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        that.status = 0;
        var datum = res.data.data;
        // 已售完且无预定
        if (datum.sellFlag == "1" && datum.statusFlag == "0") {
          that.$router.push("/");
          return;
        }
        if (datum.imageUrl.indexOf(",") !== -1) {
          datum.imgLst = datum.imageUrl.split(",");
        } else {
          datum.imgLst = [datum.imageUrl];
        }
        that.imgList = datum.imgLst;
        datum.rental = that.$box.formatSplit(datum.rental, true);
        datum.commision = that.$box.formatSplit(
          parseInt(datum.commission),
          true
        );
        datum.price = that.$box.formatSplit(datum.price, true);
        //datum.maxRental = (datum.proertyType == 'Apartments Units' || datum.proertyType == 'Townhouses') !== '' ? that.$box.formatSplit(datum.maxRental, true) : ''
        //datum.maxCommision = (datum.proertyType == 'Apartments Units' || datum.proertyType == 'Townhouses') !== '' ? that.$box.formatSplit(datum.maxCommision, true) : ''
        //datum.maxPrice = (datum.proertyType == 'Apartments Units' || datum.proertyType == 'Townhouses') !== '' ? that.$box.formatSplit(datum.maxPrice, true) : ''
        datum.maxRental =
          datum.maxRental !== 0
            ? that.$box.formatSplit(datum.maxRental, true)
            : null;
        datum.maxCommision =
          datum.maxCommision !== ""
            ? that.$box.formatSplit(parseInt(datum.maxCommision), true)
            : "";
        datum.maxPrice =
          datum.maxPrice !== ""
            ? that.$box.formatSplit(datum.maxPrice, true)
            : "";

        datum.landPrice =
          datum.landPrice !== ""
            ? that.$box.formatSplit(datum.landPrice, true)
            : "";
        datum.buildPrice =
          datum.buildPrice !== ""
            ? that.$box.formatSplit(datum.buildPrice, true)
            : "";
        datum.landPriceMax =
          datum.landPriceMax !== ""
            ? that.$box.formatSplit(datum.landPriceMax, true)
            : "";
        datum.buildPriceMax =
          datum.buildPriceMax !== ""
            ? that.$box.formatSplit(datum.buildPriceMax, true)
            : "";
        // 设置地图经纬度
        (datum.lat = datum.latitude), (datum.lng = datum.longitude);
        // 8848
        // datum.informationPack = datum.informationPack.split('https://file.alfred.store')[1]
        that.item = datum;
        that.currentRoom =
          that.item && that.item.listRoom && that.item.listRoom[0]
            ? that.item.listRoom[0]
            : {};
        that.setPropertyDtl({ data: res.data.data });
        let temp = [];
        that.item.listFloorPlan.forEach(e => {
          temp.push(e.floorPlans);
        });
        that.listFloorPlan = temp;
        this.isLoading = false;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 20001) {
        that.$router.push("/");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
      console.log(this.item);
    }
  },
  beforeUpdate() {
    let address =
      this.item.address && this.item.suburb
        ? this.item.address.trim() +
          ", " +
          this.item.suburb +
          " (" +
          this.$route.query.pid +
          ")"
        : this.item.address || this.item.suburb
        ? (this.item.address || this.item.suburb) +
          " (" +
          this.$route.query.pid +
          ")"
        : "TBA" + " (" + this.$route.query.pid + ")";
    document.title = "UNIFI Property: " + address + " - Property Details";
  },
  components: {
    HeaderSection,
    ReserveProperty,
    MoreFromAgent,
    ListingLocation,
    MeetAgent,
    ListingDetails,
    ListingDetailsTabs,
    FindOutMore,
    ContactUs,
    AgentsRegistration,
    ConnectingProperties,
    SocialSection,
    StayUpToDate,
    discoverMore,
    agentSignInSection,
    BuyOffPlanSection,
    TopImageSection,
    BreadcrumbSection,
    SimilarProperties,
    AdvertisementThree,
    AdvertisementOne,
    AdvertisementTwo,
    FooterSection,
    propertyIconSet,
    SearchSection,
    ViewMore,
    LoadMore,
    SearchingImageSection,
    SearchResultsViewChange,
    DrawerAside,
    SearchResults
  }
};
</script>

<template>
  <el-container v-track:100 class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">

        <div v-if="isLoading" class="loading-overlay">
          <div
            class="loading-spinner"
            style="display: flex; color: #003333; justify-content: center; align-items: center"
          ></div>
        </div>
        <div v-else>
          <listing-details-tabs
            :listFloorPlan="listFloorPlan"
            :props-image="this.item"
            :currentRoom="this.item"
            @updateRow="updateRow"
          />
          <listing-details
            :currentRoom="currentRoom"
            :listing-details="this.item"
          />
          <meet-agent :props-data="this.item" />
          <listing-location :listing-details="this.item" />
          <!-- <more-from-agent/> -->
<!--          <reserve-property-->
<!--            :currentRoom="currentRoom"-->
<!--            :listing-details="this.item"-->
<!--          />-->
        </div>
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  /* color: #2D2D2D; */
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}

.loading-overlay {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/detailsLayout.vue